// extracted by mini-css-extract-plugin
export default {"main":"order_main__QZsoE","orders":"order_orders__UfgTP","orderTable":"order_orderTable__PQKKB"};